const CROPS = {
  rice:   { maturityDays: 120, potential_t_per_acre: 3.5 },
  wheat:  { maturityDays: 130, potential_t_per_acre: 3.0 },
  tomato: { maturityDays: 110, potential_t_per_acre: 18.0 },
  potato: { maturityDays: 100, potential_t_per_acre: 9.0 },
};

const STAGE_WINDOWS = {
  vegetative: [0.00, 0.60],
  flowering:  [0.60, 0.85],
  fruiting:   [0.85, 1.00],
};

const STAGE_MULTIPLIER = {
  vegetative: 0.70,
  flowering:  0.90,
  fruiting:   1.00,
};

function stageFit(daysFrac, [start, end]) {
  const mid = (start + end) / 2;
  const half = (end - start) / 2;
  const dist = Math.abs(daysFrac - mid);

  if (dist <= half) return 1;
  const excess = dist - half;
  const width = end - start || 1e-6;
  const fit = Math.max(0, 1 - excess / width);
  return +fit.toFixed(3);
}

export function predictYield({
  crop,
  stage,
  daysSincePlanting,
  areaAcres,
}) {
  const key = String(crop).toLowerCase();
  if (!CROPS[key]) throw new Error("Unsupported crop");

  const s = String(stage).toLowerCase();
  if (!STAGE_WINDOWS[s]) throw new Error("Invalid stage");

  if (!(daysSincePlanting > 0)) throw new Error("Days must be > 0");

  const { maturityDays, potential_t_per_acre } = CROPS[key];
  const daysFrac = daysSincePlanting / maturityDays;
  const fit = stageFit(daysFrac, STAGE_WINDOWS[s]);
  
  const stageCert = { vegetative: 0.6, flowering: 0.8, fruiting: 0.95 }[s];
  const confidence = +(0.5 * stageCert + 0.5 * fit).toFixed(2);
  
  const base = potential_t_per_acre;
  const stageMult = STAGE_MULTIPLIER[s];
  
  const timingPenalty =
    daysFrac < 0.0 ? 0.85 :
    daysFrac > 1.2 ? 0.80 :
    daysFrac > 1.0 ? 0.90 : 1.0;

  const projected_t_per_acre = +(base * stageMult * fit * timingPenalty).toFixed(2);
  const daysToHarvest = Math.max(0, maturityDays - daysSincePlanting);

  const result = {
    crop: key,
    stage: s,
    daysSincePlanting,
    maturityDays,
    projected_t_per_acre,
    projected_kg_per_acre: Math.round(projected_t_per_acre * 1000),
    confidence: Math.round(confidence * 100),
    daysToHarvest,
  };

  if (areaAcres && areaAcres > 0) {
    result.projected_total_kg = Math.round(projected_t_per_acre * areaAcres * 1000);
  }

  return result;
}